import type { Interpolation } from "@emotion/react";

import { fontSizes } from "../../../../../global/emotion";

export type FontSize = "s" | "m" | "l";

export const fontStyles: Record<FontSize, Interpolation> = {
  s: {
    fontSize: fontSizes.tosS,
  },
  m: {
    fontSize: fontSizes.tosM,
  },
  l: {
    fontSize: fontSizes.tosL,
  },
};
